import { Editor } from '@tiptap/core';

import { Recipient } from '@bonusly/recipient-entities';

import { parseState } from './parse-state';

interface RichMediaStateData {
	amount?: number;
	hashtags?: string[];
	mentions?: Recipient[];
	recipients?: Recipient[];
	json?: any;
	plainText?: string;
	text?: string;
}

export class RichMediaState {
	public amount?: number = undefined;
	public hashtags: string[] = [];
	public mentions: Recipient[] = [];
	public recipients: Recipient[] = [];
	public json: any = {};
	public plainText = '';
	public text = '';

	constructor(data: RichMediaStateData = {}) {
		const filtered = Object.fromEntries(Object.entries(data).filter(([, value]) => value !== undefined));

		Object.assign(this, filtered);
	}

	public get hasAmount() {
		return this.amount !== undefined;
	}

	public get hasHashtag() {
		return this.hashtagCount > 0;
	}

	public get hasMention() {
		return this.mentionCount > 0;
	}

	public get hasRecipient() {
		return this.recipientCount > 0;
	}

	public get hashtagCount() {
		return this.hashtags.length;
	}

	public get mentionCount() {
		// group mentions has a users list
		const uniqueMentions = new Set<string>();
		this.mentions.forEach(({ id, type, username, userIds = [] }) => {
			if (type === 'group') {
				userIds.forEach((id) => uniqueMentions.add(id));
			} else {
				uniqueMentions.add(id || username);
			}
		});
		return Array.from(uniqueMentions).length;
	}

	public get recipientCount() {
		// plain recipients and group and remove duplicated
		const uniqueRecipients = new Set<string>();
		this.recipients.forEach(({ id, type, username, userIds = [] }) => {
			if (type === 'group') {
				userIds.forEach((id) => uniqueRecipients.add(id));
			} else {
				uniqueRecipients.add(id || username);
			}
		});
		return Array.from(uniqueRecipients).length;
	}

	public get totalAmount() {
		const amount = this.amount ?? 0;
		return amount * this.recipientCount;
	}

	public static parse(editor: Editor | null) {
		return parseState(editor);
	}
}
